import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, HostListener, Inject, Input } from '@angular/core';
import { ImgUrls } from '../../models/imgUrls.interface';
import { CANNOT_BE_UNDONE } from '../../constants/strings';
import { UtilService } from '../../util.service';
import { MatIconButtonComponent } from '../mat-icon-button/mat-icon-button.component';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-image-carousel-modal-content',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatIconButtonComponent],
  templateUrl: './image-carousel-modal-content.component.html',
  styleUrls: ['./image-carousel-modal-content.component.css'],
})
export class ImageCarouselModalContentComponent implements AfterViewInit {
  @Input() selectedId = 0;
  @Input() imgUrls: ImgUrls[] = [];
  /**
   * The name of the image
   */
  @Input() altName?: string;
  @Input() deleteImageCallback: ((index: number) => void) | undefined;
  noImagesText = `Keine Bilder vorhanden.`;

  constructor(
    public utilService: UtilService,
    private dialogRef: MatDialogRef<ImageCarouselModalContentComponent>,
    @Inject(MAT_DIALOG_DATA)
    data?: { selectedId?: number; imgUrls?: ImgUrls[]; altName?: string; deleteImageCallback?: (index: number) => void },
  ) {
    this.selectedId = data?.selectedId ?? 0;
    this.imgUrls = data?.imgUrls ?? [];
    this.altName = data?.altName ?? this.altName;
    this.deleteImageCallback = data?.deleteImageCallback ?? this.deleteImageCallback;
  }

  ngAfterViewInit(): void {
    this.dialogRef.addPanelClass('image-carousel-dialog-ready');
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'ESC') {
      this.dialogRef.close('ESC press');
    }
    if (event.key === 'ArrowLeft') {
      this.previousImage();
    }
    if (event.key === 'ArrowRight') {
      this.nextImage();
    }
  }

  onDeleteImage(): any {
    this.dialogRef.close('ESC press');

    if (this.deleteImageCallback && this.selectedId !== undefined) {
      const title = `Are you sure you want to delete this image?`;
      this.utilService.showConfirmDialog(
        title,
        CANNOT_BE_UNDONE,
        this.deleteImage.bind(this),
        undefined,
        undefined,
        undefined,
        undefined,
        'no',
      );
    }
  }

  deleteImage(): void {
    if (this.deleteImageCallback) this.deleteImageCallback(+this.selectedId);
  }

  previousImage(): void {
    if (!this.imgUrls.length) return;
    this.selectedId = (this.selectedId - 1 + this.imgUrls.length) % this.imgUrls.length;
  }

  nextImage(): void {
    if (!this.imgUrls.length) return;
    this.selectedId = (this.selectedId + 1) % this.imgUrls.length;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
